/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Features_Embeddings_UnlimitedInputs */

const es_components_upgrade_plan_modal_features_embeddings_unlimited = /** @type {(inputs: Components_Upgrade_Plan_Modal_Features_Embeddings_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embeddings ilimitados por mes`)
};

const en_components_upgrade_plan_modal_features_embeddings_unlimited = /** @type {(inputs: Components_Upgrade_Plan_Modal_Features_Embeddings_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited embeddings per month`)
};

/**
* | output |
* | --- |
* | "Unlimited embeddings per month" |
*
* @param {Components_Upgrade_Plan_Modal_Features_Embeddings_UnlimitedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_features_embeddings_unlimited = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Features_Embeddings_UnlimitedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Features_Embeddings_UnlimitedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_features_embeddings_unlimited(inputs)
	return en_components_upgrade_plan_modal_features_embeddings_unlimited(inputs)
});
export { components_upgrade_plan_modal_features_embeddings_unlimited as "components.upgrade_plan_modal.features.embeddings_unlimited" }